exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.card-collapse > .card-header[data-v-8068dbe6] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.card.card-collapse > .card-header > h4[data-v-8068dbe6] {\n    text-transform: capitalize;\n}\n.card.card-collapse > .card-header > i[data-v-8068dbe6] {\n    cursor: pointer;\n    transition: transform ease-in-out 200ms;\n}\n.card.card-collapse.is-openned > .card-header > i[data-v-8068dbe6] {\n  transform: rotate(90deg);\n}\n", ""]);

// exports
